import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import { getClassName } from "./functions";
import MenuContainer from "../MenuContainer";

class MenuWrapper extends PureComponent {
  static contextType = AppContext;
  render() {
    const { isMenuShown } = this.context;
    return (
      <section className={getClassName(isMenuShown)}>
        <MenuContainer />
      </section>
    );
  }
}

export default MenuWrapper;
